import { useTranslation } from "react-i18next";
import SelectCampusMultiChoice from "../../../SelectCampusMultiChoice";
import SelectCampus from "../../../SelectCampus";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import { useEffect, useState } from "react";
import { DatePicker, Select, Table, TableColumnsType } from "antd";
import moment from "moment";
import Button from "../../../Button";
import FinancialDatePicker from "../FinancialDatePicker";
import { DateTableType, IncomePageType } from "../../../../constans";
import useAxios from "../../../../hooks/useAxios";
import { IGetTreeSubcodes, ITreeSubCodeReq } from "../../../../models/treeCodes.model";
import { getSubcodes } from "../../../../api/treeCodes.api";
import { IGetIncomeList, IGetTotalAmount, IIncomeList, IIncomeListParams } from "../../../../models/financials.model";
import config from "../../../../lib/config";
import Pagination from "../../../Pagination";
import DownloadButton from "../../../DownloadButton";
import Split from "react-split";
import IncomeCreate from "./Create";
import IncomeEdit from "./Edit";
import IncomeRead from "./Read";
import { getIncomes, getIncomeTotalAmount } from "../../../../api/financials.api";
import _ from "lodash";
import { getCommonCodeLabel } from "../../../../lib/store";
import Loader from "../../../Loader";
import exportTable from "../../../../lib/exportTable";
import IncomeCopy from "./Copy";
import styled from "styled-components";

const Block = styled.div`
    .income-title {
        width: 190px;
    }
    .income-title div {
        width: 190px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: no-wrap;
    }
`;

const IncomeList = () => {

    const maxPageSize = 9999999;
    const { t, i18n } = useTranslation();
    const { auth } = useSelector((state: RootState) => state.auth);

    const [campusCodes, setCampusCodes] = useState<string[]>([]);
    const [srtDate, setSrtDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [defSelType, setDefSelType] = useState<number>(0);
    const commonCode = "FA0002";  //수입 트리공통코드
    const { commonCodes } = useSelector((state: RootState) => state.commonCode);
    // FB0001 = 조건
    const FB0001 = commonCodes.find(item => item.commonCode === 'FB0001')?.detailCode;
    // FB0002 = 입금방법
    const FB0002 = commonCodes.find(item => item.commonCode === 'FB0002')?.detailCode;
    // FB0003 = 입금여부
    const FB0003 = commonCodes.find(item => item.commonCode === 'FB0003')?.detailCode;

    const [searchType, setSearchType] = useState("");
    const [incomeMtd, setIncomeMtd] = useState("");
    const [incomeYn, setIncomeYn] = useState("");
    const [account1, setAccount1] = useState("");
    const [account2, setAccount2] = useState("");
    const [account3, setAccount3] = useState("");
    const [incomeDesc, setIncomeDesc] = useState("");
    const {data: incomeList, isLoading: isLoading1, error: error1, execute: executeList } = useAxios<IGetIncomeList>();
    const {data: incomeTotalAmt, isLoading: isLoading2, error: error2, execute: executeTotalAmt } = useAxios<IGetTotalAmount>();
    const {data: account1Data, isLoading: isLoadinga1, error: errora1, execute } = useAxios<IGetTreeSubcodes>();
    const {data: account2Data, isLoading: isLoadinga2, error: errora2, execute: execute2 } = useAxios<IGetTreeSubcodes>();
    const {data: account3Data, isLoading: isLoadinga3, error: errora3, execute: execute3 } = useAxios<IGetTreeSubcodes>();
    const [account2Res, setAccount2Res] = useState<IGetTreeSubcodes>();
    const [account3Res, setAccount3Res] = useState<IGetTreeSubcodes>();
    const [page, setPage] = useState(1);
    const [incomeRefineList, setIncomeRefineList] = useState<IIncomeList[]>([]);
    const [pageType, setPageType] = useState(IncomePageType.CREATE); 
    const [incomeAmount, setIncomeAmount] = useState('0');
    const [exportTableLoading, setExportTableLoading] = useState(false);
    const [selectedIncomeCode, setSelectedIncomeCode] = useState<any>();
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [selectsKeys, setSelectsKeys] = useState<React.Key[]>([]);
    const [copyIncomeCode, setCopyIncomeCode] = useState<number>();
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    
    useEffect(() => {
        getAccountCodes(1, 0);

        const defaultDate = moment(new Date());  //작성일
        setSrtDate(moment(defaultDate).format('YYYYMM01'));
        setEndDate(moment(defaultDate).format('YYYYMMDD'));
    },[]);

    useEffect(() => {
        if(account2Data) {
            setAccount2Res({...account2Data});
        }
    },[account2Data])

    useEffect(() => {
        if(account3Data) {
            setAccount3Res({...account3Data});
        }
    },[account3Data])

    useEffect(() => {
        if (FB0001) {
            setSearchType(FB0001[0].detailCode);
        }
      }, [FB0001]);

    useEffect(() => {
        if(incomeList) {
            let tempIncomeList : IIncomeList[]  = _.cloneDeep(incomeList.data);

            if (tempIncomeList.length > 0) {
                let tempNo = 1;
                tempIncomeList.forEach((item: IIncomeList) => {
                    item.no = (config.pageSize * (page-1)) + tempNo;
                    tempNo++;
                    item.incomeDate = moment(item.incomeDate).format("YYYY-MM-DD");
                    item.incomeMtd = getCommonCodeLabel('FB0002', item.incomeMtd, i18n.language); 
                    item.incomeYn = getCommonCodeLabel('FB0003', item.incomeYn, i18n.language); 
                    item.memberName = item.memberName + ((item.memberEngName) ? '(' + item.memberEngName + ')' : "");
                });
            }
            setIncomeRefineList(tempIncomeList);
            initSelects();
        }    
    }, [incomeList]);

    /*  페이징 maxPageSize 미사용 시 해제
    useEffect(() => {
        if(isFirstLoad) {
            setIsFirstLoad(false);
            return;
        }
        getIncomeList('P');
    }, [page]);
    */

    useEffect(() => {
        if(incomeTotalAmt?.data) {
            setIncomeAmount(incomeTotalAmt.data.totalAmount.toLocaleString());
        }
    }, [incomeTotalAmt]);

    const renderContent = () => {
        switch (pageType) {
            case IncomePageType.CREATE:
                return <IncomeCreate 
                        getIncomeList={getIncomeList} 
                        setSelectedRow={setSelectedIncomeCode} 
                        setPageType={setPageType} 
                        />;
            case IncomePageType.UPDATE:
                return <IncomeEdit 
                        incomeCode={selectedIncomeCode} 
                        commonCode={commonCode} 
                        getIncomeList={getIncomeList} 
                        setPageType={setPageType} 
                        />;
            case IncomePageType.COPY:
                return <IncomeCopy 
                        getIncomeList={getIncomeList} 
                        commonCode={commonCode} 
                        setSelectedRow={setSelectedIncomeCode} 
                        setPageType={setPageType} 
                        incomeCode={copyIncomeCode} 
                        />;
            case IncomePageType.VIEW:
                return <IncomeRead 
                        getIncomeList={getIncomeList} 
                        incomeCode={selectedIncomeCode} 
                        commonCode={commonCode} 
                        setPageType={setPageType} 
                        />;
            default:
                return <IncomeCreate 
                        getIncomeList={getIncomeList} 
                        setSelectedRow={setSelectedIncomeCode} 
                        setPageType={setPageType} 
                        />;
        }
    }

    const getAccountCodes = (treeLevel: number, parentDetailCode: number) => {
        const param: ITreeSubCodeReq = {
            commonCode: commonCode,
            parentDetailCode: parentDetailCode,
            treeLevel: treeLevel,
            useYn: 'Y'
        }

        if(treeLevel === 1) {   //계정1
            execute(getSubcodes(commonCode, param));
        } else if(treeLevel === 2) {
            execute2(getSubcodes(commonCode, param));
        } else if(treeLevel === 3) {
            execute3(getSubcodes(commonCode, param));
        }
    }

    const getIncomeList = (listType: 'A' | 'P') => {
        const campusCode = auth.hqYn === 'Y'
            ? campusCodes
            : (campusCodes.length ? campusCodes : auth.campus);
        
        const incomeListParam: IIncomeListParams = {
            campusCodes: campusCode,
            searchType: searchType,
            firstIncomeAccCode: account1,
            secondIncomeAccCode: account2,
            thirdIncomeAccCode: account3,
            incomeMtd: incomeMtd,
            incomeYn: incomeYn,
            incomeSrtDate: srtDate,
            incomeEndDate: endDate,
            incomeDesc: incomeDesc,
            treeCommonCode: commonCode,
            pageNo: 1,
            perPage: maxPageSize
        }

        executeList(getIncomes(incomeListParam));
        if(listType === 'A') {
            executeTotalAmt(getIncomeTotalAmount(incomeListParam));
        }

        setPage(1);
    }

    const incomeRowClick = (record : any) => {
        setSelectedRow(record);
        setSelectedIncomeCode(record?.incomeCode);
            
        setPageType(IncomePageType.VIEW);
    }

    const initSelects = () => {
        setSelectsKeys([]);
    }

    const rowSelection = {
        selectedRowKeys: selectsKeys,
        onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
          setSelectsKeys(selectedRowKeys);
        }
    };

    const onCopy = () => {
        if(selectsKeys.length === 1) {
            setCopyIncomeCode(Number(selectsKeys[0]));
            setPageType(IncomePageType.COPY)
        }
    }

    const columns: TableColumnsType<IIncomeList> = [
        {
            title: '#',
            dataIndex: 'no',
            key: 'no',
            align: 'center',
            sorter: (a, b) => a.no - b.no
        },
        {
          title: t('common.menu.campus'),
          dataIndex: 'campusName',
          key: 'campusName',
          align: 'center',
          render: (value, record) => (i18n.language === 'ko' ? value : record.campusEngName),
          sorter: (a, b) => a.campusCode.localeCompare(b.campusCode)
        },
        {
          title: t('payment.income.column1'),
          dataIndex: 'incomeDate',
          key: 'incomeDate',
          align: 'center',
          render: (value) => (moment(value).format('YYYY-MM-DD')),
          sorter: (a, b) => a.incomeDate.localeCompare(b.incomeDate)
        },
        {
          title: t('payment.income.search2') + '1',
          dataIndex: 'firstIncomeAccName',
          key: 'firstIncomeAccName',
          align: 'center',
          render: (value, record) => (i18n.language === 'ko' ? value : record.firstIncomeAccEngName),
          sorter: (a, b) => a.firstIncomeAccName.localeCompare(b.firstIncomeAccName)
        },
        {
            title: t('payment.income.search2') + '2',
            dataIndex: 'secondIncomeAccName',
            key: 'secondIncomeAccName',
            align: 'center',
            render: (value, record) => (i18n.language === 'ko' ? value : record.secondIncomeAccEngName),
            sorter: (a, b) => a.secondIncomeAccName.localeCompare(b.secondIncomeAccName)
        },
        {
            title: t('payment.income.search2') + '3',
            dataIndex: 'thirdIncomeAccName',
            key: 'thirdIncomeAccName',
            align: 'center',
            render: (value, record) => (i18n.language === 'ko' ? value : record.thirdIncomeAccEngName),
            sorter: (a, b) => a.thirdIncomeAccName.localeCompare(b.thirdIncomeAccName)
        },        
        {
            title: t('payment.income.search5'),
            dataIndex: 'incomeDesc',
            key: 'incomeDesc',
            align: 'center',
            className: 'income-title',
            sorter: (a, b) => a.incomeDesc.localeCompare(b.incomeDesc),
            render: value => (<div className='text-left'>{value}</div>)
        },
        {
            title: t('payment.income.column2'),
            dataIndex: 'incomeMtd',
            key: 'incomeMtd',
            align: 'center',
            render: (value) => (value),
            sorter: (a, b) => a.incomeMtd.localeCompare(b.incomeMtd)
        },
        {
            title: t('common.column.writer'),
            dataIndex: 'memberName',
            key: 'memberName',
            align: 'center',
            sorter: (a, b) => a.memberName.localeCompare(b.memberName)
        },
        {
            title: t('payment.income.column3'),
            dataIndex: 'currency',
            key: 'currency',
            align: 'center'
        },
        {
            title: t('payment.income.column4'),
            dataIndex: 'amount',
            key: 'amount',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + value.toLocaleString()}</div>),
            sorter: (a, b) => a.amount - b.amount
        },
        {
            title: t('payment.income.search4'),
            dataIndex: 'incomeYn',
            key: 'incomeYn',
            align: 'center',
            render: value => (value),
            sorter: (a, b) => a.incomeYn.localeCompare(b.incomeYn)
        },
        {
            title: t('payment.income.column5'),
            dataIndex: 'completeYn',
            key: 'completeYn',
            align: 'center',
            render: (value) => (value==="Y"?
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4 9.938 9.647 15 16 6" stroke="#5DBECD" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                :""),
            sorter: (a, b) => a.completeYn.localeCompare(b.completeYn)
        },
    ];

    const onExportTable = () => {
        setExportTableLoading(true);
        const currentDate = moment(new Date());
        
        if(selectsKeys.length > 1) {
            const excelDownloadList = incomeRefineList.filter((item)=>{
                const result = selectsKeys.find((value)=>value === item.incomeCode);
                if(result) {
                    return true;
                }
            });
            
            exportTable(columns, excelDownloadList, `${t('payment.income.tab1')}_(${currentDate.format('YYYYMMDD')})`, `${t('payment.income.tab1')}`, [20,15,15,15,15,30,10,20,10,15,10,10] );
        } else {
            exportTable(columns, incomeRefineList, `${t('payment.income.tab1')}_(${currentDate.format('YYYYMMDD')})`, `${t('payment.income.tab1')}`, [20,15,15,15,15,30,10,20,10,15,10,10] );
        }
        
        setExportTableLoading(false);
    }

    return (
        <>
            {exportTableLoading ? <Loader /> : null}
            <div className="common-search">
                <div className="search-area">
                    <ul className="search-bx">
                        <li>
                            <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
                            {
                                auth && (auth.hqYn === 'Y')
                                ? (
                                <>
                                    <SelectCampusMultiChoice
                                    placeholder={t('statistics.eLearning.title2')}
                                    onChange={setCampusCodes}
                                    value={campusCodes}
                                    />
                                    <label>
                                    ({campusCodes.length ? `${campusCodes.length}${t('statistics.attendance.text1')}` : t('common.text.all')})
                                    </label>
                                </>
                                )
                                : <SelectCampus />
                            }
                        </li>
                        <li>
                            <label>{t('payment.income.search1')}</label> {/* 조건 */}
                            <Select
                                value={searchType}
                                onChange={(value)=>{setSearchType(value)}}
                            >
                                {
                                    FB0001?.map((item)=>{
                                        return(
                                            <Select.Option
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                                {i18n.language === 'ko' ? item.korName : item.engName}
                                            </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li>
                            <label>{t('payment.income.search2') + '1'}</label> {/* 계정1 */}
                            <Select                                
                                value={account1}
                                onChange={(value)=>{
                                    setAccount1(value);
                                    getAccountCodes(2,Number(value));
                                    setAccount2("");
                                    setAccount3("");
                                    setAccount2Res(undefined);
                                    setAccount3Res(undefined);
                                }}
                            >
                                <Select.Option value="">
                                    {t('common.text.all')}
                                </Select.Option>
                                {
                                    account1Data?.data?.map((item) => {
                                        return(
                                            <Select.Option
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                            {i18n.language === 'ko' ? item.korName : item.engName}
                                          </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li>
                            <label>{t('payment.income.search2') + '2'}</label> {/* 계정2 */}
                            <Select
                                value={account2}
                                onChange={(value)=>{
                                    setAccount2(value);
                                    setAccount3("");
                                    getAccountCodes(3,Number(value));
                                    setAccount3Res(undefined);
                                }}
                            >
                                <Select.Option value="">
                                    {t('common.text.all')}
                                </Select.Option>
                                {
                                    account2Res?.data?.map((item) => {
                                        return(
                                            <Select.Option
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                            {i18n.language === 'ko' ? item.korName : item.engName}
                                          </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li>
                            <label>{t('payment.income.search2') + '3'}</label> {/* 계정3 */}
                            <Select
                                value={account3}
                                onChange={(value)=>{
                                    setAccount3(value);
                                }}
                            >
                                <Select.Option value="">
                                    {t('common.text.all')}
                                </Select.Option>
                                {
                                    account3Res?.data?.map((item) => {
                                        return(
                                            <Select.Option
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                            {i18n.language === 'ko' ? item.korName : item.engName}
                                          </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li>
                            <label>{t('payment.income.search3')}</label> {/* 입금방법 */}
                            <Select
                                value={incomeMtd}
                                onChange={(value)=>{
                                    setIncomeMtd(value);
                                }}
                            >
                                <Select.Option value="">
                                    {t('common.text.all')}
                                </Select.Option>
                                {
                                    FB0002?.map((item)=>{
                                        return(
                                            <Select.Option
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                                {i18n.language === 'ko' ? item.korName : item.engName}
                                            </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li>
                            <label>{t('payment.income.search4')}</label> {/* 입금여부 */}
                            <Select
                                value={incomeYn}
                                onChange={(value)=>{
                                    setIncomeYn(value);
                                }}
                            >
                                <Select.Option value="">
                                    {t('common.text.all')}
                                </Select.Option>
                                {
                                    FB0003?.map((item)=>{
                                        return(
                                            <Select.Option
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                                {i18n.language === 'ko' ? item.korName : item.engName}
                                            </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li className="period">
                            <label>{t('sms.list.column1')}</label> {/* 기간 */}
                            <div className="comm-btn__area">
                                <FinancialDatePicker
                                    setStartDate={setSrtDate}
                                    setEndDate={setEndDate}
                                    type={DateTableType.Simple}
                                    defSelType={defSelType}
                                    setDefSelType={setDefSelType}
                                />
                            </div>
                            <div className="date-picker__area">
                                <DatePicker
                                value={srtDate ? moment(srtDate) : undefined}
                                onChange={e => {
                                    if (e === null) setSrtDate('');
                                    else setSrtDate(moment(e).format('YYYYMMDD'))
                                }}
                                format={['YYYY-MM-DD', 'YYYYMMDD']}
                                />
                            </div>
                            ~
                            <div className="date-picker__area">
                                <DatePicker
                                value={endDate ? moment(endDate) : undefined}
                                onChange={e => {
                                    if (e === null) setEndDate('');
                                    else setEndDate(moment(e).format('YYYYMMDD'))
                                }}
                                format={['YYYY-MM-DD', 'YYYYMMDD']}
                                />
                            </div>
                            
                        </li>
                        <li>
                            <label>{t('payment.income.search5')}</label> {/* 내역 */}
                            <input
                                type="text"
                                className="form-control w-150p mr-1"
                                value={incomeDesc}
                                onChange={(e)=>{ setIncomeDesc(e.target.value)}}/*(e) => setKeyword(e.target.value)*/
                            />
                            <div className="comm-btn__area">
                                <Button
                                    className="btn-basic small black"
                                    onClick={() => getIncomeList('A')}
                                    text={t('common.button.search')}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <Split 
                className='splite-divide'
                sizes={[65, 35]}
                minSize={100}
                expandToMin={false}
                gutterSize={10}
                gutterAlign="center"
                snapOffset={30}
                dragInterval={1}
                direction="horizontal"
                cursor="col-resize"
            >
                <div className='col-frame left_panel wrap-financial wrap-income'>
                    <div className="inner">
                        <div className="comm-bx__between">  
                            <div className="comm-sch_result">
                                {t('payment.income.lable1') + ' : '}<b>{incomeAmount}</b>{' ' + t('class.class.text6')}
                            </div>
                        </div>
                        <Block className="comm-table__area ml-th">
                            <Table
                                columns={columns}
                                dataSource={incomeRefineList}
                                pagination={{
                                    current: page,
                                    pageSize: config.pageSize,
                                }}
                                rowKey={'incomeCode'}
                                rowSelection={{
                                    type: 'checkbox',
                                    ...rowSelection,
                                }}
                                onRow={(record) => {
                                    return {
                                    onClick: () => {
                                        incomeRowClick(record);
                                    },
                                    };
                                }}
                                rowClassName={(record: any) =>
                                    record.incomeCode === selectedRow?.incomeCode
                                        ? 'chosen'
                                        : 'pointer'
                                }
                            />
                        </Block>
                        <div className="comm-bx__between">
                            <div className="comm-btn__area">
                                <DownloadButton onClick={onExportTable} />
                                <Button
                                    onClick={onCopy}
                                    className="btn-basic pink-line"
                                    text={t('campus.shuttle.button3')}
                                    disabled={((selectsKeys.length === 1)?false:true )}
                                    /*writeAuthYn={writeAuthYn}*/
                                />
                                <Button
                                    onClick={() => {
                                        setPageType(IncomePageType.CREATE)
                                    }}
                                    className="btn-basic pink"
                                    text={t('common.button.create')}
                                    /*writeAuthYn={writeAuthYn}*/
                                />
                            </div>
                            <div className="common-paging right">
                                <Pagination
                                    count={incomeList?.total || 0}
                                    page={page}
                                    setPage={setPage}
                                    perPage={config.pageSize}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='finan_right_panel'>
                    {renderContent()}
                </div>
            </Split>
        </>
    )
}

export default IncomeList;